import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { I18nClientService } from 'src/app/shared-resources/base-i18n/services/i18n-client.service';
import { TranslateService } from '@ngx-translate/core';
import { FormDrawerService } from 'src/app/shared-resources/services/form-drawer.service';
import { ModalBuilderService } from '@shared-services/modal-builder.service';
import { FtaAdvisorComponent } from '../fta-advisor/fta-advisor.component';

@Component({
  selector: 'app-layout-home',
  templateUrl: './layout-home.component.html',
  styleUrls: ['./layout-home.component.less'],
})
export class LayoutHomeComponent implements OnInit {
  public isUserAdmin = false;
  public isCommonResourceLoaded = false;
  public showHeaderMenu = false;
  public isIntelligenceSuite=false;
  public isInventory=false; 
  public inventoryArray = ["./assets/img/Man_in_warehouse.jpg",
    "./assets/img/Warehouse.jpg",
    "./assets/img/Woman_using_tablet_in_a_warehouse.jpg"
  ];
  public intelligenceArray = ["./assets/img/Man-in-office-1.jpg",
    "./assets/img/Graph-1.jpg",
    "./assets/img/Woman-working-on-a-computer.jpg",
    "./assets/img/Graph.jpg",
  ]
  constructor(
    private i18nClientService: I18nClientService,
    public router: Router,
    private formDrawerService: FormDrawerService,
    private translate: TranslateService,
    private modalBuilderService: ModalBuilderService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.indexOf('/login') >= 0) {
          this.showHeaderMenu = true;
        } else {
          this.showHeaderMenu = false;
        }
      }
    });
  }

  ngOnInit(): void {
    if (
      window.location.href.indexOf('/admin-ui') >= 0 ||
      window.location.href.indexOf('/studio') >= 0
    ){
      this.isUserAdmin = true;
    } else if( window.location.href.indexOf('/intelligencesuite-ui') >= 0){
      this.isIntelligenceSuite=true;
    } else if(window.location.href.indexOf('/inventory-ui') >= 0 ){
      this.isInventory=true; 
    }
    this.i18nClientService.commonResourceLoaded$.subscribe((result) => {
      this.isCommonResourceLoaded = !result;
    });
  }
  ftaAdvisor(): void {
    this.modalBuilderService.openModalForm(FtaAdvisorComponent, {}, this.translate.instant('app.login.fta-advisor'));
  }
}
